import { j as o } from "../../jsx-runtime-B6kdoens.js";
import { useContext as F } from "react";
import { c as j, a as y } from "../../index-CROKJrb5.js";
import { c as v, f as b } from "../../create-component-CBAeEoQ6.js";
import { F as H } from "../../FormControlContext-C7A4R-3o.js";
import { FormControlLabel as h } from "./FormControlLabel/index.js";
import { FormControlHelperText as w } from "./FormControlHelperText/index.js";
import { FormControlHighlight as L } from "./FormControlHighlight/index.js";
import { FormControlRequired as N } from "./FormControlRequired/index.js";
const R = (r) => typeof r == "string" ? /* @__PURE__ */ o.jsx(h, { children: r }) : r, c = (r) => typeof r == "string" ? /* @__PURE__ */ o.jsx(w, { children: r }) : r, g = (r, e) => typeof r == "string" ? /* @__PURE__ */ o.jsx(L, { className: e, children: r }) : r, k = j({
  variants: {
    screenreaderOnly: {
      true: "cur-sr-only"
    }
  }
}), J = v(
  "FormControl",
  b(
    ({
      children: r,
      className: e,
      fieldClassName: i,
      fieldProps: a,
      helperText: s,
      highlight: t,
      highlightClassName: f,
      label: n,
      required: d = !1,
      size: z,
      state: O,
      ...x
    }, p) => {
      const { id: u, inGroup: C, type: l } = F(H), m = l === "checkbox" || l === "radio";
      return /* @__PURE__ */ o.jsxs("div", { ref: p, className: e, ...x, children: [
        n && /* @__PURE__ */ o.jsxs(
          "label",
          {
            htmlFor: u,
            className: k({ screenreaderOnly: C }),
            children: [
              /* @__PURE__ */ o.jsxs("div", { className: "cur-flex cur-items-baseline", children: [
                R(n),
                d && /* @__PURE__ */ o.jsx(N, {})
              ] }),
              m ? c(s) : null
            ]
          }
        ),
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            className: y(
              "cur-flex cur-w-full cur-flex-wrap cur-transition-all",
              i
            ),
            ...a,
            children: [
              r,
              t && g(t, f)
            ]
          }
        ),
        m ? null : c(s)
      ] });
    }
  )
);
export {
  J as FormControl,
  H as FormControlContext,
  c as renderFormControlHelperText,
  g as renderFormControlHighlight,
  R as renderFormControlLabel
};
//# sourceMappingURL=index.js.map
